<template>
  <div class="container">
    <!-- {{ myregFormData }} -->
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">[기관] 신청문의<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="st_myreg_customize_form">
          <form
            name="myreg_form"
            ENCTYPE="multipart/form-data"
            style="margin: 0"
          >
            <table class="st_myreg_form">
              <caption>
                기본정보
              </caption>
              <colgroup>
                <col style="width: 250px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>기관명 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.orgName"
                    />
                  </td>
                </tr>

                <tr>
                  <th>우편번호</th>
                  <td>
                    <input
                      type="text"
                      name="postCode"
                      id="postCode"
                      v-model="myregFormData.address.postCode"
                      style="width: 120px"
                    />
                    <n-button
                      type="primary"
                      ghost
                      @click="openPostcodeSearch"
                      size="small"
                      style="margin-left: 5px"
                    >
                      주소검색
                    </n-button>
                  </td>
                </tr>
                <tr>
                  <th>주소</th>
                  <td>
                    <input
                      type="text"
                      name="address"
                      id="address"
                      v-model="myregFormData.address.address"
                      style="width: 100%"
                    />
                  </td>
                </tr>
                <tr>
                  <th>상세주소</th>
                  <td>
                    <input
                      type="text"
                      name="addressDetail"
                      id="addressDetail"
                      v-model="myregFormData.address.addressDetail"
                      style="width: 100%"
                    />
                  </td>
                </tr>
                <tr>
                  <th>대상 인원수 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.examineeCount"
                    />
                  </td>
                </tr>
                <tr>
                  <th>담당 부서 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.deptName"
                    />
                  </td>
                </tr>
                <tr>
                  <th>담당자 이름 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.name"
                    />
                  </td>
                </tr>
                <tr>
                  <th>연락처 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v1"
                      id="s_v1"
                      v-model="myregFormData.phoneNumber"
                    />
                  </td>
                </tr>
                <tr>
                  <th>이메일 <span class="st_myreg_required">*</span></th>
                  <td>
                    <input
                      type="text"
                      name="s_v3"
                      id="s_v3"
                      v-model="myregFormData.email"
                    />
                  </td>
                </tr>
                <tr>
                  <th>문의대상</th>
                  <td>
                    <textarea
                      readonly
                      v-model="myregFormData.targetProduct"
                      style="width: 100%; height: 150px"
                    ></textarea>
                  </td>
                </tr>
                <tr>
                  <th>내 용 <span class="st_myreg_required">*</span></th>
                  <td>
                    <textarea
                      name="s_t1"
                      id="s_t1"
                      v-model="myregFormData.content"
                      style="width: 100%; height: 150px"
                    ></textarea>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="st_myreg_agree_wrap st_myreg_mgt">
              <h4 class="st_myreg_title">개인정보 수집·이용 동의</h4>
              <div class="st_myreg_agree">
                <div class="st_myreg_agree_box">
                  <h5>수집하는 개인정보의 항목</h5>
                  <p>
                    회사는 회원가입, 상담, 서비스 신청 등을 위해 아래와 같은
                    개인정보를 수집하고 있습니다.
                  </p>
                  <ul>
                    <li>수집항목 : 이 름, 핸드폰, 이메일, 내 용, 파일첨부</li>
                    <li>개인정보 수집방법 : <span>홈페이지</span></li>
                  </ul>
                  <h5>개인정보의 수집 및 이용목적</h5>
                  <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
                  <ul>
                    <li>연락 및 상담<br /></li>
                  </ul>
                  <h5>개인정보의 보유 및 이용기간</h5>
                  <p>
                    회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이
                    해당 정보를 지체 없이 파기합니다.
                  </p>
                </div>
                <div class="agree_check_box">
                  <input
                    type="checkbox"
                    name="myreg_privacy_chk"
                    id="myreg_privacy_chk"
                    value="1"
                  />
                  <span>
                    <input
                      type="radio"
                      name="myreg_privacy_radio"
                      id="myreg_privacy_radio_agree"
                      value="agree"
                      v-model="myregFormData.privacyAgreement"
                    />
                    <label for="myreg_privacy_radio_agree"
                      >개인정보 수집·이용에 동의합니다.</label
                    >
                  </span>
                  <span>
                    <input
                      type="radio"
                      name="myreg_privacy_radio"
                      id="myreg_privacy_radio_disagree"
                      value="disagree"
                      v-model="myregFormData.privacyAgreement"
                    />
                    <label for="myreg_privacy_radio1"
                      >개인정보 수집·이용에 동의하지 않습니다.</label
                    >
                  </span>
                </div>
              </div>
            </div>
            <div class="st_myreg_btn_wrap">
              <n-button
                type="primary"
                @click="submitInquiry"
                :loading="isLoading"
                :disabled="isLoading"
              >
                "확인"
              </n-button>
            </div>
            <div
              v-if="successMessage"
              class="success-message"
              style="color: blue; margin-top: 10px; text-align: center"
            >
              {{ successMessage }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import { ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/bbs/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env"; // Firebase Callable Function
import { OrgMyreg } from "@/model/myreg"; // Myreg 모델 임포트
import { useNotification, NButton } from "naive-ui"; // NButton 임포트 추가
import { useAlertDialog } from "@/composables/useAlert";
const useAlert = useAlertDialog();

const router = useRouter();
const route = useRoute();
const notification = useNotification();

const initialFormData: OrgMyreg = {
  orgName: "",
  deptName: "",
  name: "",
  address: {
    postCode: "",
    address: "",
    addressDetail: "",
  },
  examineeCount: 0,
  phoneNumber: "",
  email: "",
  content: "",
  targetProduct: "",
  privacyAgreement: "", // 'agree' 또는 'disagree'
};

const myregFormData = ref<OrgMyreg>({ ...initialFormData });
const isLoading = ref<boolean>(false);
const successMessage = ref<string | null>(null);

const addOrgMyreg = getCallable("addOrgMyreg");

const openPostcodeSearch = async () => {
  if (
    typeof (window as any).daum === "undefined" ||
    typeof (window as any).daum.Postcode === "undefined"
  ) {
    await useAlert(
      "Daum 우편번호 서비스가 로드되지 않았습니다. 페이지를 새로고침하거나 관리자에게 문의하세요."
    );
    return;
  }
  new (window as any).daum.Postcode({
    oncomplete: (data: any) => {
      let addr = ""; // 주소 변수
      let extraAddr = ""; // 참고항목 변수

      //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
      if (data.userSelectedType === "R") {
        // 사용자가 도로명 주소를 선택했을 경우
        addr = data.roadAddress;
      } else {
        // 사용자가 지번 주소를 선택했을 경우(J)
        addr = data.jibunAddress;
      }

      // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
      if (data.userSelectedType === "R") {
        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraAddr += data.bname;
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraAddr +=
            extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraAddr !== "") {
          extraAddr = " (" + extraAddr + ")";
        }
      }

      myregFormData.value.address.postCode = data.zonecode;
      myregFormData.value.address.address = addr + extraAddr;
      document.getElementById("addressDetail")?.focus(); // 상세주소 필드로 포커스 이동
    },
  }).open();
};

const submitInquiry = async () => {
  successMessage.value = null;

  if (
    !myregFormData.value.orgName ||
    !myregFormData.value.deptName ||
    !myregFormData.value.examineeCount ||
    !myregFormData.value.name ||
    !myregFormData.value.phoneNumber ||
    !myregFormData.value.email
  ) {
    await useAlert("필수 입력 항목을 모두 채워주세요.");
    return;
  }
  if (myregFormData.value.privacyAgreement !== "agree") {
    await useAlert("개인정보 수집·이용에 동의해주세요.");

    return;
  }

  isLoading.value = true;

  try {
    const result: any = await addOrgMyreg(myregFormData.value);
    if (result.data && result.data.error) {
      throw new Error(result.data.message || "문의 등록에 실패했습니다.");
    }
    notification.success({
      title: "성공",
      description: "문의가 성공적으로 등록되었습니다.",
      duration: 2000,
      onAfterLeave: () => {
        router.push(`${USER_ROUTES.Home.Path}`);
      },
    });
  } catch (error: any) {
    console.error("Error submitting inquiry:", error);

    notification.error({
      title: "실패",
      description:
        error.message ||
        "문의 등록 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
      duration: 2000,
    });
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  const productId = route.params.pid as string;
  if (productId == "P_PUTT") {
    myregFormData.value.targetProduct =
      "PUTT2.0 다중재능검사_초등학생용(고)\r\nPUTT2.0 다중재능검사_중학생용\r\nPUTT2.0 다중재능검사_고등학생용\r\nPUTT2.0 다중재능검사_대학생용";
  } else if (productId == "P_TOCC") {
    myregFormData.value.targetProduct =
      "TOCC 창의역량검사_초등학생용(고)\r\nTOCC 창의역량검사_청소년용\r\nTEC 창의역량검사_(예비)전문가용";
  } else if (productId == "P_PUTT_TOCC") {
    myregFormData.value.targetProduct =
      "PUTT2.0_초등학생용(고) + TOCC아동용(고)\r\nPUTT2.0_중학생용 + TOCC_청소년용\r\nPUTT2.0_고등학생용 + TOCC_청소년용\r\nPUTT2.0_대학생용 + TEC_(예비)전문가용";
  } else if (productId == "C_PUTT") {
    myregFormData.value.targetProduct =
      "PUTT2.0기반 상담코칭_초등학생 (고)\r\nPUTT2.0기반 상담코칭_중학생PUTT2.0기반 상담코칭_고등학생\r\nPUTT2.0기반 상담코칭_대학생";
  } else if (productId == "C_TOCC") {
    myregFormData.value.targetProduct =
      "TOCC기반 상담코칭_초등학생 (고)\r\nTOCC기반 상담코칭_중학생\r\nTOCC기반 상담코칭_고등학생\r\nTOCC기반 상담코칭_대학생";
  } else if (productId == "C_PUTT_TOCC") {
    myregFormData.value.targetProduct =
      "PUTT‧TOCC 상담코칭_초등학생 (고)\r\nPUTT‧TOCC 상담코칭_중학생\r\nPUTT‧TOCC 상담코칭_고등학생\r\nPUTT‧TEC 상담코칭_대학생";
  } else if (productId == "Talent") {
    myregFormData.value.targetProduct =
      "PUTT2.0 기반 재능탐색 프로젝트_초등학생(고)\r\nPUTT2.0 기반 진로탐색 프로젝트_중학생\r\nPUTT2.0 기반 전공탐색 프로젝트_고등학생\r\nPUTT2.0 기반 직업탐색 프로젝트_대학생";
  } else if (productId == "Startup") {
    myregFormData.value.targetProduct =
      "재능 발견으로 꿈을 창업하다!_초등학생(고)\r\n재능 발휘로 꿈을 창업하다!_중학생\r\n재능 디자인으로 꿈을 창업하다!_고등학생용";
  } else if (productId == "Career") {
    myregFormData.value.targetProduct =
      "진로코칭지도사 체험 활동_초등학생(고)\r\n진로코칭지도사 체험 활동_중학생\r\n진로코칭지도사 체험 활동_고등학생\r\n진로코칭지도사 체험 활동_대학생용";
  } else if (productId == "Growth") {
    myregFormData.value.targetProduct =
      "성장-폴리오 중학생 과정\r\n성장-폴리오 고등학생 과정\r\n성장-폴리오 대학생 과정";
  } else if (productId == "Expert_e") {
    myregFormData.value.targetProduct = "다중재능코칭 전문가 교육 - 초급과정";
  } else if (productId == "Expert_h") {
    myregFormData.value.targetProduct =
      "다중재능코칭 전문가 교육 - 고급과정\r\n※ 이수자에 다중재능코칭전문가 2급 자격증 부여";
  } else if (productId == "Expert_b") {
    myregFormData.value.targetProduct =
      "다중재능코칭 전문가 교육 - 최고과정\r\n※ 이수자에 다중재능코칭전문가 1급 자격증 부여";
  } else if (productId == "Expert_p") {
    myregFormData.value.targetProduct = "성장 – 폴리오 전문가 과정";
  } else {
    myregFormData.value.targetProduct = "기타";
  }
});
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");

  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.sub_scroll_wrap {
  overflow: hidden;
  height: 39px;
  border-bottom: 1px solid #ccc;
  background: #fff;
}
.sub_scroll_wrap > div {
  position: relative; /*padding: 0 30px;*/
}
.sub_scroll_wrap > div > div {
  overflow-x: scroll;
}
.sub_scroll_wrap > div > div .scroll_nav {
  display: inline-block;
  min-width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
  font-size: 0;
  text-align: center;
  white-space: nowrap;
}
.sub_scroll_wrap > div > div .scroll_nav li {
  display: inline-block;
}
.sub_scroll_wrap > div > div .scroll_nav li a {
  display: inline-block;
  height: 39px;
  line-height: 39px;
  padding: 0 12px;
  font-size: 13px;
  color: #bbb;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  box-sizing: border-box;
  font-weight: 600;
}
.sub_scroll_wrap > div > div .scroll_nav li.on a {
  color: #be7b42;
  font-weight: 600;
}
.sub_scroll_wrap > div i {
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 39px;
}
.sub_scroll_wrap > div i.prev:before {
  content: "";
  position: absolute;
  top: 0;
  left: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-right-color: #333;
}
.sub_scroll_wrap > div i.next {
  right: 0;
  left: inherit;
}
.sub_scroll_wrap > div i.next:before {
  content: "";
  position: absolute;
  top: 0;
  right: 3px;
  bottom: 0;
  width: 0;
  height: 0;
  margin: auto;
  border: 6px solid transparent;
  border-left-color: #333;
}
@media screen and (min-width: 768px) {
  .sub_scroll_wrap > div i {
    display: none;
  }
}
@media screen and (min-width: 1200px) {
  .sub_scroll_wrap {
    overflow: visible;
    height: auto;
    border-bottom: none;
    background: #fff;
    box-shadow: 3px 3px 3px rgb(0 0 0 / 10%);
  }
  .sub_scroll_wrap > div {
    position: relative;
    padding: 0;
  }
  .sub_scroll_wrap > div > div {
    overflow: hidden;
  }
  .sub_scroll_wrap > div > div .scroll_nav {
    display: table;
    margin: 0;
    width: 100%;
    padding: 0;
    white-space: normal;
    text-align: left;
    border-collapse: collapse;
  }
  .sub_scroll_wrap > div > div .scroll_nav li {
    display: table-cell;
    width: 33%;
    position: relative;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    background: #bbb;
    width: 1px;
    height: 15px;
    margin-top: -7px;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:last-child:after {
    display: none;
  }
  .sub_scroll_wrap > div > div .scroll_nav li:before {
    position: absolute;
    visibility: hidden;
    left: 0;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 3px;
    background: #be7b42;
    content: "";
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: all 0.2s ease-in-out 0s;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.85;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 60px;
    line-height: 60px;
    padding: 0 5px;
    font-size: 16px;
    text-align: center;
    color: #bbbbbb;
    font-weight: 600;
  }
  .sub_scroll_wrap > div > div .scroll_nav li a:hover {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on a {
    color: #be7b42;
  }
  .sub_scroll_wrap > div > div .scroll_nav li.on:before,
  .sub_scroll_wrap > div > div .scroll_nav li:hover:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.sub1 * {
  font-family: "Noto Sans", NanumGothic, "나눔고딕", "Open Sans", sans-serif;
  box-sizing: border-box;
  word-break: keep-all;
}
.sub1 {
  background: #f5f5f5;
  padding: 100px 10px;
  text-align: center;
  line-height: 1.7em;
}

.st_myreg_title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}
.st_myreg_mgt {
  margin-top: 40px;
}
.st_myreg_customize_form > h1 {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 18px;
  margin-bottom: 20px;
  color: #df0011;
  word-break: keep-all;
}
.st_myreg_form {
  width: 100%;
  border-top: 2px solid #a5a5a5;
  border-bottom: 1px solid #a5a5a5;
  background: #fff;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  margin-bottom: 50px;
}
.st_myreg_form * {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_form + .st_myreg_form {
  margin-top: 40px;
}
.st_myreg_form caption {
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  text-align: left;
}
.st_myreg_form tbody tr th {
  position: relative;
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #f5f5f5;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  font-weight: 500;
  border-right: 1px solid #ddd;
}
.st_myreg_form tbody tr td {
  height: 30px;
  padding: 10px;
  border-top: 1px solid #ddd;
  background: #fff;
  font-size: 13px;
  color: #666;
  line-height: 22px;
}
.st_myreg_form tbody tr:first-child th,
.st_myreg_form tbody tr:first-child td {
  border-top-width: 0;
}
.st_myreg_form tbody tr td > input[type="text"],
.st_myreg_form tbody tr td > input[type="number"],
.st_myreg_form tbody tr td > input[type="password"] {
  box-sizing: border-box;
  max-width: 100%;
  height: 30px;
  margin: 2px 0;
  padding: 0 5px;
  border: 1px solid #ddd;
  font-size: 13px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > input[type="radio"],
.st_myreg_form tbody tr td > input[type="checkbox"] {
  margin: 0 5px 0 0;
}
.st_myreg_form tbody tr td > textarea {
  box-sizing: border-box;
  margin: 2px 0;
  padding: 10px;
  border: 1px solid #ddd;
  line-height: 22px;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > select {
  height: 30px;
  margin: 2px 0;
  vertical-align: middle;
}
.st_myreg_form tbody tr td > a,
.st_myreg_form tbody tr td > input[type="button"] {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 30px;
  margin: 2px 0 2px 5px;
  padding: 0 15px;
  background: #dfdfdf;
  font-size: 12px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 30px;
  vertical-align: middle;
  cursor: pointer;
}
.st_myreg_form a:hover:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
}
.st_myreg_form label {
  margin-right: 15px;
  cursor: pointer;
}
.st_myreg_form .st_myreg_form_info {
  display: block;
  margin-top: 5px;
  color: #888888;
}
.st_myreg_form .st_myreg_required {
  color: #ef0000;
}
.st_myreg_form #total_price_str {
  vertical-align: top;
}

.st_myreg_payment_type {
  margin: 0 0 20px;
  padding: 15px;
  background: #f4f4f4;
  font-weight: bold;
  color: #777;
  line-height: 22px;
}
.st_myreg_payment_type input {
  margin: 0 5px 0 15px;
}
.st_myreg_payment_type:first-child {
  margin-left: 0;
}
.st_myreg_payment_type label {
  font-size: 13px;
  cursor: pointer;
}
.st_myreg_payment_type font {
  position: relative;
  top: -2px;
  margin-left: 6px;
}
.st_myreg_payment_type * {
  vertical-align: middle;
}
.st_myreg_payment_type br {
  display: none;
}

.st_myreg_btn_wrap {
  margin: 30px 0 0;
  padding: 0;
  text-align: center;
}
.st_myreg_btn_wrap a,
.st_myreg_btn_wrap button {
  margin: 2px 0;
}
.st_myreg_btn_wrap * {
  vertical-align: top;
}

.st_myreg_agree_wrap .st_myreg_title {
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
  font-size: 15px;
}
.st_myreg_agree_wrap .st_myreg_agree {
  padding: 10px;
  background: #f6f6f6;
}
.st_myreg_agree_wrap .st_myreg_agree_box {
  display: block;
  overflow: auto;
  height: 150px;
  padding: 30px;
  border: 1px solid #ddd;
  background: #fff;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5 {
  margin-bottom: 10px;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box h5:first-child {
  margin-top: 0;
}
.st_myreg_agree_wrap .st_myreg_agree_box p,
.st_myreg_agree_wrap .st_myreg_agree_box ul,
.st_myreg_agree_wrap .st_myreg_agree_box ol {
  margin: 0;
  padding: 0;
  font-size: 13px;
  list-style-type: none;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box li {
  margin-bottom: 10px;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .st_myreg_agree_box p {
  margin-bottom: 10px;
}

.st_myreg_agree_wrap .agree_check_box {
  margin: 10px 0 0;
}
.st_myreg_agree_wrap .agree_check_box:after {
  content: "";
  display: block;
  clear: both;
}
.st_myreg_agree_wrap .agree_check_box span {
  display: inline-block;
}
.st_myreg_agree_wrap .agree_check_box input {
  float: left;
}
.st_myreg_agree_wrap .agree_check_box label {
  float: left;
  margin-left: 5px;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  font-family: "Montserrat", "Noto Sans", NanumGothic, "나눔고딕", "Open Sans",
    sans-serif;
}
.st_myreg_agree_wrap .agree_check_box input[type="checkbox"] {
  display: none;
}

.st_myreg_btn_type1 {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  height: 45px;
  margin: 0;
  padding: 12px 30px;
  background: #dfdfdf;
  background: #dfdfdf;
  font-family: "Malgun Gothic", sans-serif;
  font-size: 13px;
  color: #5f5f5f;
  font-weight: bold;
  line-height: 21px;
  cursor: pointer;
}
.st_myreg_btn_type1:hover:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.05);
}
.st_myreg_btn_type1.st_myreg_highlight {
  background: #4e4e4e;
  color: #ffffff;
}
.st_myreg_btn_type1.st_myreg_highlight:hover:before {
  background: rgba(255, 255, 255, 0.15);
}

@media all and (max-width: 767px) {
  .st_myreg_form:after {
    content: "";
    display: block;
    clear: both;
  }
  .st_myreg_form colgroup {
    display: none;
  }
  .st_myreg_form tbody tr th {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 10px;
    text-align: left;
    border-right: none;
  }
  .st_myreg_form tbody tr th:after {
    display: none;
  }
  .st_myreg_form tbody tr td {
    box-sizing: border-box;
    display: block;
    float: left;
    width: 100%;
    height: auto;
    padding: 0 10px 10px;
    border-top-width: 0;
  }

  .st_myreg_payment_type br {
    display: block;
  }
  .st_myreg_payment_type input {
    margin-left: 0;
  }
  .st_myreg_agree_wrap .st_myreg_agree_box {
    height: 100px;
  }
}
</style>
